export const useLocalizedPath = () => {
  const localePath = useLocalePath()
  const portalUrlRegex = /^https:\/\/(portal|portaltst|portaldev)\.gmpplus\.org(\/.*)?$/
  const route = useRoute()

  const getLocalizedPath = (path: string) => {
    if (/^https?:\/\//.test(path)) {
      if (portalUrlRegex.test(path)) return path // external, don't localize
    }
    return localePath(path)
  }

  const getReferrerPolicy = (path: string) => {
    return portalUrlRegex.test(path) ? 'origin' : 'strict-origin-when-cross-origin'
  }

  const isExternalLink = (path: string) => /^https?:\/\//.test(path)

  const isPathActive = (currentPath: string, targetPath: string) => {
    return currentPath === targetPath || currentPath.startsWith(`${targetPath}/`)
  }

  const isActive = (path: string | { path: string }) => {
    const currentPath = normalizePath(route.path)
    if (typeof path === 'string') {
      if (path.startsWith('#')) return false
      if (isExternalLink(path)) return false
      return isPathActive(currentPath, normalizePath(path))
    }
    if (path.path.startsWith('#')) return false
    if (isExternalLink(path.path)) return false
    return isPathActive(currentPath, normalizePath(path.path))
  }

  const normalizePath = (path: string) => {
    return localePath(path, 'en') // normalize the path to the default locale
  }

  return {
    getLocalizedPath,
    localePath,
    getReferrerPolicy,
    isExternalLink,
    isActive,
    normalizePath,
  }
}
